export namespace Analytics {
  export enum GA_EVENT_CATEGORIES {
    DEVICES = 'Devices',
    FILES = 'Files',
    CLIENTS = 'Clients',
    USERS = 'Users',
  }
}
